export const loginPageTexts = {
    header: 'Welcome to the Customer Portal',
    description: 'Your private access to all your Gecko business info: current orders, history, price lists, product lists, submitted cases and much more...',
    signInButton: 'SIGN IN',
};
